import { LoadableElement } from '@99designs/common/components/LoadableElement';
import { getBriefType, getBriefTypeVariables } from '__generated__/getBriefType';
import { handleGraphQLError } from 'common/utils/Apollo';
import React from 'react';
import { Query } from 'react-apollo';
import { RouteComponentProps, withRouter } from 'react-router';
import { BriefFieldsRedirect } from '.';
import query from './BriefRedirect.graphql';

type Props = RouteComponentProps<{
    briefId: string;
}>;

const BriefRedirect: React.FunctionComponent<Props> = props => (
    <Query<getBriefType, getBriefTypeVariables>
        query={query}
        variables={{
            id: props.match.params.briefId,
        }}
    >
        {({ error, loading, data }) => {
            if (loading) {
                return <LoadableElement variations={['fade-in']} isLoading={true} />;
            }

            if (error) {
                handleGraphQLError(error);
            }

            if (data) {
                return <BriefFieldsRedirect brief={data.structuredBrief} />;
            }
            return null;
        }}
    </Query>
);

export default withRouter(BriefRedirect);
